// extracted by mini-css-extract-plugin
export default {"header":"header---eJAiq","positive":"positive---T2kDU","headerStart":"headerStart---gqxWz"};